<template>
    <div class="modal fade" id="moveToProcessingModal" tabindex="-1" aria-labelledby="moveToProcessingModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-header">
                        <h5 class="modal-title">Move Order to Processing</h5>
                        <!-- <button type="button" class="btn-close" @click="hideModal"></button> -->
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label">Reason for Moving to Processing</label>
                            <Field 
                                name="comment" 
                                as="textarea" 
                                rows="3"
                                class="form-control" 
                                id="reasonInput" 
                                placeholder="Enter reason for moving to processing"
                                :class="{ 'is-invalid': errors.comment }"
                                v-model="orderData.comment"
                            />
                            <div v-if="errors.comment" class="is-invalid invalid-feedback">{{ errors.comment }}</div>
                        </div>
                        <p>Are you sure you want to move this order to processing?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="hideModal">Cancel</button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-theme"
                            :disabled="processing"
                            :class="{'disabled': processing}"
                            v-text="processing ? 'Processing...' : 'Confirm Move'"
                            @click="handleSubmit($event, updateOrder)"
                        ></button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "MoveToProcessing",
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            processing: false,
            orderData: {
                id: this.order.id,
                status: "processing",
                comment: ''
            }
        };
    },
    computed: {
        schema() {
            return {
                comment: 'required'
            };
        }
    },
    methods: {
        updateOrder() {
            let self = this;
            this.processing = true;
            axios
                .post('/api/admin/orders/update-status', {
                    order_id: this.order.id,
                    status: "processing",
                    comment: this.orderData.comment,
                    action: "move_to_processing"
                })
                .then(response => {
                    // Hide the modal
                    self.hideModal();
                    
                    // Show success notification
                    self.$notification(response.data.status, response.data.message);

                    // Emit event to parent component
                    self.$emit('order-updated');

                    // Emit event to refresh the order list
                    self.$emitter.emit('refresh-order-list', {order: self.orderData});
                })
                .catch(error => {
                    self.$notification("error", error.response.data.message);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        showModal() {
            $('#moveToProcessingModal').modal('show');
        },
        hideModal() {
            $('#moveToProcessingModal').modal('hide');

            this.$emitter.emit('reset-selected-order');
        }
    }
}
</script>